import { Bug } from "lucide-react";
import { VERSION } from "@/version";

export default function AppVersion() {
  const bugReportUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfjEZ2tUL_16f1WnGZUYkodnU5z24VhNd-1h0ESFu2pq6rJDw/viewform?usp=header";

  // The release number is VERSION in src/version.js (bumped every release).
  // Fetching /package.json only ever got index.html back, logged
  // "Error fetching version" and fell back to package.json's unrelated 3.6.1.
  return (
    <div className="text-center space-y-2 py-2">
      <div className="text-xs text-gray-400">Version {VERSION}</div>
      <button
        onClick={() => window.open(bugReportUrl, "_blank")}
        className="inline-flex items-center gap-2 px-3 py-1 text-xs text-gray-500 hover:text-[#F30099] transition-colors"
        data-gtm-element-id="footer_bug-report_button-1"
      >
        <Bug className="w-3 h-3" />
        Report a Bug
      </button>
    </div>
  );
}
